import servers from "./servers";

export default {
  [servers.user]: "https://user-api.jilingshu.com.cn",
  [servers.exam]: "https://exam-center-service.jilingshu.com.cn",
  [servers.device]: "https://api.jilingshu.com.cn",
  [servers.authorization]: "https://api.jilingshu.com.cn",
};
